module.exports = __webpack_public_path__ + "img/categories.c950e0e0.png";